import axios from 'axios'
import errorParser from '@/utils/error-parser'

export default {
  listForFacility (facilityId) {
    return new Promise((resolve, reject) => {
      axios.get('/facilities/' + facilityId + '/meteringpoints').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  getMeteringPoint (meteringPointId) {
    return new Promise((resolve, reject) => {
      axios.get('/meteringpoints/' + meteringPointId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  patchMeteringPoint (meteringPointId, patch) {
    return new Promise((resolve, reject) => {
      axios.patch('/meteringpoints/' + meteringPointId, patch).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  swap (meteringPointId, payload) {
    // payload: { cdcsensorid, firstvalue, endvalue?, swapnote? }
    return new Promise((resolve, reject) => {
      axios.post('/meteringpoints/' + meteringPointId + '/swap', payload).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
